import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBlast = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 256 256",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M49 128.5V26h50.75c54.8.02 57.96.27 68.18 5.46 6.12 3.09 15.87 12.04 18.73 17.16l2.15 3.88-14.23 14.62-14.24 14.61-1.1-4.11c-1.57-5.88-5.12-10.62-9.74-13.03-3.73-1.95-5.89-2.11-32.27-2.4l-28.27-.3.27 22.8.27 22.81 34.5.54c32.7.51 34.84.66 41 2.84 9.32 3.29 16.69 8.08 23.58 15.31 11.66 12.24 15.47 21.62 16.15 39.81.56 14.76-.9 22.48-6.38 33.88-4.75 9.87-14.48 19.6-24.59 24.57-12.77 6.29-15.3 6.51-73.01 6.53L49 231V128.5Zm100.25 64.07c9.25-3.3 15.57-11.53 16.47-21.45 1.11-12.24-3.55-21.86-12.82-26.48l-5.29-2.64H89v52l28.25-.04c20.97-.04 29.22-.39 32-1.39Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M195.68 134.66c-1.96-2.76-4.3-5.53-7.1-8.47-6.89-7.23-14.26-12.02-23.58-15.31-5.67-2.01-7.93-2.29-33.74-2.72l21.98.34 15.65-16c8.6-8.8 20.32-20.84 26.04-26.75 5.73-5.91 10.85-10.75 11.39-10.75 1.51 0 .01 27.47-1.88 34.5-2.45 9.12-7.25 17.28-14.52 24.7l-6.58 6.71 4.88 4.8c2.96 2.91 5.38 5.78 7.46 8.95Z",
		fill: "currentColor",
		opacity: .55
	})]
});
export default SvgBlast;
